import { render, staticRenderFns } from "./DashboardFertilidad.vue?vue&type=template&id=367ad0de&scoped=true"
import script from "./DashboardFertilidad.vue?vue&type=script&lang=js"
export * from "./DashboardFertilidad.vue?vue&type=script&lang=js"
import style0 from "./DashboardFertilidad.vue?vue&type=style&index=0&id=367ad0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ad0de",
  null
  
)

export default component.exports